import './bootstrap.js';
import './scripts.js';
import './slick.min.js';
import './bundle_old.js';
